

(function( ){
//------------------------------------------------------------------------------------------------------------------------------


	var Main = function( )
	{
		var _this = this , i ;

		//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -

		// この中に処理を書いていってください。
		$('.inner-box .ttl').tile(3);

		var slider;
		var slidenum;

		$('.list-block a').each(function(){
			$(this).click(function(){
				slidenum = $(this).attr("date-num");
				slider = $(this).attr('data-remodal-target');


				$(document).on('opening', '.modal-slider-area', function () {
					modalSlider($("#" + slider), slidenum);
				}).on('closed', '.modal-slider-area', function () {
					$("#" + slider).slick('unslick');
				});
			});
		});

		function modalSlider(element,slidenum){
			element.not('.slick-initialized').slick({
				initialSlide:   parseInt(slidenum),
				slidesToShow:   1,
				centerMode:     true,
				centerPadding:  '0',
				infinite:       true,
				adaptiveHeight: true,
				prevArrow:      '<a class="slick-prev slider-arrow" href="javascript:void(0)"></a>',
				nextArrow:      '<a class="slick-next slider-arrow" href="javascript:void(0)"></a>',
			});
		}



		//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -

		// リサイズイベントを使うときは、この_onResize内に処理を書いてください。
		// リサイズイベントを綱わないようでしたら決してください。
		// var _onResize = function( )
		// {

		// }

		// _onResize( ) ;
		// FitContents.addTask( _onResize ) ;
	}


//------------------------------------------------------------------------------------------------------------------------------


	window.requestAnimationFrame = 	window.requestAnimationFrame ||
									window.webkitRequestAnimationFrame ||
									function( func ){ return setTimeout( func , 1000/60 ) ; } ;


	window.cancelAnimationFrame = 	window.cancelAnimationFrame ||
									window.webkitCancelAnimationFrame ||
									function( id ){ clearTimeout( id ) ; } ;


	document.readyState === "complete"
		? setTimeout( function(){ new Main( ) ; } , 1 )
		: document.addEventListener( "DOMContentLoaded", function(){ new Main( ) ; } ) ;


//------------------------------------------------------------------------------------------------------------------------------


} )( ) ;
